/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaymentRetryView_viewer$ref = any;
export type routes_PaymentRetryView_QueryVariables = {|
  ids?: ?$ReadOnlyArray<string>
|};
export type routes_PaymentRetryView_QueryResponse = {|
  +viewer: ?{|
    +id: string,
    +firstname: ?string,
    +creditCards: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +ccBrand: ?string,
          +ccHolder: ?string,
          +ccLast4: ?string,
          +ccExpMonth: ?number,
          +ccExpYear: ?number,
        |}
      |}>
    |},
    +salesOrders: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +status: ?number,
          +shippingTotal: ?number,
          +shippingDescription: ?string,
          +subtotal: ?number,
          +grandTotal: ?number,
          +surcharge: ?number,
          +surcharges: ?$ReadOnlyArray<?{|
            +name: ?string,
            +amount: ?number,
          |}>,
          +discount: ?number,
          +discounts: ?$ReadOnlyArray<?{|
            +id: ?string,
            +name: ?string,
            +code: ?string,
            +amount: ?number,
          |}>,
          +paymentMethod: ?string,
          +verification: ?any,
          +lines: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +quantity: ?number,
                +unitPrice: ?number,
                +unitDiscount: ?number,
                +unitSurcharge: ?number,
                +rowTotal: ?number,
                +configParent: ?{|
                  +id: string,
                  +urlSlug: ?string,
                  +mainImage: ?{|
                    +id: string,
                    +thumbnail: ?string,
                  |},
                |},
                +product: ?{|
                  +urlSlug: ?string,
                  +status: ?string,
                  +mainImage: ?{|
                    +id: string,
                    +url: ?string,
                    +thumbnail: ?string,
                  |},
                |},
                +shipments: ?$ReadOnlyArray<?{|
                  +tracking: ?any,
                  +location: ?string,
                  +status: ?string,
                  +timestamp: ?string,
                |}>,
                +children: ?{|
                  +edges: ?$ReadOnlyArray<?{|
                    +node: ?{|
                      +id: string,
                      +name: ?string,
                      +quantity: ?number,
                      +unitPrice: ?number,
                      +unitDiscount: ?number,
                      +unitSurcharge: ?number,
                      +rowTotal: ?number,
                      +product: ?{|
                        +urlSlug: ?string,
                        +status: ?string,
                        +mainImage: ?{|
                          +id: string,
                          +url: ?string,
                          +thumbnail: ?string,
                        |},
                      |},
                      +shipments: ?$ReadOnlyArray<?{|
                        +tracking: ?any,
                        +location: ?string,
                        +status: ?string,
                        +timestamp: ?string,
                      |}>,
                    |}
                  |}>
                |},
              |}
            |}>
          |},
        |}
      |}>
    |},
    +$fragmentRefs: PaymentRetryView_viewer$ref,
  |}
|};
export type routes_PaymentRetryView_Query = {|
  variables: routes_PaymentRetryView_QueryVariables,
  response: routes_PaymentRetryView_QueryResponse,
|};
*/


/*
query routes_PaymentRetryView_Query(
  $ids: [ID!]
) {
  viewer {
    ...PaymentRetryView_viewer
    id
    firstname
    creditCards(first: 999) {
      edges {
        node {
          id
          ccBrand
          ccHolder
          ccLast4
          ccExpMonth
          ccExpYear
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    salesOrders(first: 1, ids: $ids) {
      edges {
        node {
          id
          name
          status
          shippingTotal
          shippingDescription
          subtotal
          grandTotal
          surcharge
          surcharges {
            name
            amount
          }
          discount
          discounts {
            id
            name
            code
            amount
          }
          paymentMethod
          verification
          lines(first: 99) {
            edges {
              node {
                id
                name
                quantity
                unitPrice
                unitDiscount
                unitSurcharge
                rowTotal
                configParent {
                  id
                  urlSlug
                  mainImage {
                    id
                    thumbnail
                  }
                }
                product {
                  urlSlug
                  status
                  mainImage {
                    id
                    url
                    thumbnail
                  }
                  id
                }
                shipments {
                  tracking
                  location
                  status
                  timestamp
                }
                children(first: 99) {
                  edges {
                    node {
                      id
                      name
                      quantity
                      unitPrice
                      unitDiscount
                      unitSurcharge
                      rowTotal
                      product {
                        urlSlug
                        status
                        mainImage {
                          id
                          url
                          thumbnail
                        }
                        id
                      }
                      shipments {
                        tracking
                        location
                        status
                        timestamp
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment PaymentRetryView_viewer on Customer {
  id
  firstname
  creditCards(first: 999) {
    edges {
      node {
        id
        ccBrand
        ccHolder
        ccLast4
        ccExpMonth
        ccExpYear
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  salesOrders(first: 1, ids: $ids) {
    edges {
      node {
        id
        name
        status
        shippingTotal
        shippingDescription
        subtotal
        grandTotal
        surcharge
        surcharges {
          name
          amount
        }
        discount
        discounts {
          id
          name
          code
          amount
        }
        paymentMethod
        verification
        lines(first: 99) {
          edges {
            node {
              id
              name
              quantity
              unitPrice
              unitDiscount
              unitSurcharge
              rowTotal
              configParent {
                id
                urlSlug
                mainImage {
                  id
                  thumbnail
                }
              }
              product {
                urlSlug
                status
                mainImage {
                  id
                  url
                  thumbnail
                }
                id
              }
              shipments {
                tracking
                location
                status
                timestamp
              }
              children(first: 99) {
                edges {
                  node {
                    id
                    name
                    quantity
                    unitPrice
                    unitDiscount
                    unitSurcharge
                    rowTotal
                    product {
                      urlSlug
                      status
                      mainImage {
                        id
                        url
                        thumbnail
                      }
                      id
                    }
                    shipments {
                      tracking
                      location
                      status
                      timestamp
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstname",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditCardEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CreditCard",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ccBrand",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ccHolder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ccLast4",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ccExpMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ccExpYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shippingTotal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shippingDescription",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtotal",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grandTotal",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surcharge",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderSurcharge",
  "kind": "LinkedField",
  "name": "surcharges",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Discount",
  "kind": "LinkedField",
  "name": "discounts",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentMethod",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verification",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitPrice",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitDiscount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitSurcharge",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowTotal",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "configParent",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductImage",
      "kind": "LinkedField",
      "name": "mainImage",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v25/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "mainImage",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v25/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v6/*: any*/),
    (v27/*: any*/)
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesShipmentLine",
  "kind": "LinkedField",
  "name": "shipments",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tracking",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v6/*: any*/),
    (v27/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_PaymentRetryView_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": "creditCards",
            "args": null,
            "concreteType": "CreditCardConnection",
            "kind": "LinkedField",
            "name": "__App_viewer_creditCards_connection",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SalesOrderConnection",
            "kind": "LinkedField",
            "name": "salesOrders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrder",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": (v18/*: any*/),
                        "concreteType": "SalesOrderLineConnection",
                        "kind": "LinkedField",
                        "name": "lines",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrderLineEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrderLine",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v5/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v26/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v18/*: any*/),
                                    "concreteType": "SalesOrderLineConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SalesOrderLineEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SalesOrderLine",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              (v5/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/),
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              (v28/*: any*/),
                                              (v29/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "children(first:99)"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "lines(first:99)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PaymentRetryView_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_PaymentRetryView_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v30/*: any*/),
            "concreteType": "CreditCardConnection",
            "kind": "LinkedField",
            "name": "creditCards",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": "creditCards(first:999)"
          },
          {
            "alias": null,
            "args": (v30/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "App_viewer_creditCards",
            "kind": "LinkedHandle",
            "name": "creditCards"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SalesOrderConnection",
            "kind": "LinkedField",
            "name": "salesOrders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrderEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrder",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": (v18/*: any*/),
                        "concreteType": "SalesOrderLineConnection",
                        "kind": "LinkedField",
                        "name": "lines",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrderLineEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrderLine",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v5/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v26/*: any*/),
                                  (v31/*: any*/),
                                  (v29/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v18/*: any*/),
                                    "concreteType": "SalesOrderLineConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SalesOrderLineEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SalesOrderLine",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              (v5/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/),
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              (v31/*: any*/),
                                              (v29/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "children(first:99)"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "lines(first:99)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5cd7da641daa2414a8c5cf81d9275736",
    "id": null,
    "metadata": {},
    "name": "routes_PaymentRetryView_Query",
    "operationKind": "query",
    "text": "query routes_PaymentRetryView_Query(\n  $ids: [ID!]\n) {\n  viewer {\n    ...PaymentRetryView_viewer\n    id\n    firstname\n    creditCards(first: 999) {\n      edges {\n        node {\n          id\n          ccBrand\n          ccHolder\n          ccLast4\n          ccExpMonth\n          ccExpYear\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    salesOrders(first: 1, ids: $ids) {\n      edges {\n        node {\n          id\n          name\n          status\n          shippingTotal\n          shippingDescription\n          subtotal\n          grandTotal\n          surcharge\n          surcharges {\n            name\n            amount\n          }\n          discount\n          discounts {\n            id\n            name\n            code\n            amount\n          }\n          paymentMethod\n          verification\n          lines(first: 99) {\n            edges {\n              node {\n                id\n                name\n                quantity\n                unitPrice\n                unitDiscount\n                unitSurcharge\n                rowTotal\n                configParent {\n                  id\n                  urlSlug\n                  mainImage {\n                    id\n                    thumbnail\n                  }\n                }\n                product {\n                  urlSlug\n                  status\n                  mainImage {\n                    id\n                    url\n                    thumbnail\n                  }\n                  id\n                }\n                shipments {\n                  tracking\n                  location\n                  status\n                  timestamp\n                }\n                children(first: 99) {\n                  edges {\n                    node {\n                      id\n                      name\n                      quantity\n                      unitPrice\n                      unitDiscount\n                      unitSurcharge\n                      rowTotal\n                      product {\n                        urlSlug\n                        status\n                        mainImage {\n                          id\n                          url\n                          thumbnail\n                        }\n                        id\n                      }\n                      shipments {\n                        tracking\n                        location\n                        status\n                        timestamp\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PaymentRetryView_viewer on Customer {\n  id\n  firstname\n  creditCards(first: 999) {\n    edges {\n      node {\n        id\n        ccBrand\n        ccHolder\n        ccLast4\n        ccExpMonth\n        ccExpYear\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  salesOrders(first: 1, ids: $ids) {\n    edges {\n      node {\n        id\n        name\n        status\n        shippingTotal\n        shippingDescription\n        subtotal\n        grandTotal\n        surcharge\n        surcharges {\n          name\n          amount\n        }\n        discount\n        discounts {\n          id\n          name\n          code\n          amount\n        }\n        paymentMethod\n        verification\n        lines(first: 99) {\n          edges {\n            node {\n              id\n              name\n              quantity\n              unitPrice\n              unitDiscount\n              unitSurcharge\n              rowTotal\n              configParent {\n                id\n                urlSlug\n                mainImage {\n                  id\n                  thumbnail\n                }\n              }\n              product {\n                urlSlug\n                status\n                mainImage {\n                  id\n                  url\n                  thumbnail\n                }\n                id\n              }\n              shipments {\n                tracking\n                location\n                status\n                timestamp\n              }\n              children(first: 99) {\n                edges {\n                  node {\n                    id\n                    name\n                    quantity\n                    unitPrice\n                    unitDiscount\n                    unitSurcharge\n                    rowTotal\n                    product {\n                      urlSlug\n                      status\n                      mainImage {\n                        id\n                        url\n                        thumbnail\n                      }\n                      id\n                    }\n                    shipments {\n                      tracking\n                      location\n                      status\n                      timestamp\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a86af28771f4797f970057c00b8a2115';

module.exports = node;
